<template>
  <div>
    <label :for="id">{{ label }}</label>
    <input 
      type="text" 
      :name="name" 
      :id="id" 
      :value="value"
      @input="$emit('input', $event.target.value)" />
  </div>
</template>

<script>
export default {
  name: "AcInput",
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    },
    value: {}
  },
  data() {
    return {
      id: this.name
    }
  }
};
</script>



// WEBPACK FOOTER //
// admin/src/js/components/AcInput.vue